import url from '../../utils/url';

const DATA_ATTR = 'data-urlparamvalue';
const CONDITIONALS_SEL = '.conditional .component--conditional-url-child-container';

class ConditionalURLContainer {
  constructor (componentRoot, { urlParamKey }) {
    this.init(componentRoot, urlParamKey);
  }

  init(componentRoot, urlParamKey) {
    const queryParamsAndValues = url.getUrlParams(window.location.href);

    // check whether our query param is present and has a value
    const queryParamMatches = queryParamsAndValues && Object.keys(queryParamsAndValues).includes(urlParamKey);
    const queryParamValue = queryParamMatches && queryParamsAndValues[urlParamKey];

    // get all the possible values to check against
    const queryParamValues = queryParamValue &&
      Array.from(componentRoot.querySelectorAll(CONDITIONALS_SEL)).map(
        ({ attributes }) => attributes.getNamedItem(DATA_ATTR).value
      );

    const queryParamValueMatches = queryParamValue && queryParamValues && queryParamValues.includes(queryParamValue);

    // if there's a match show the matched child(ren) otherwise show the default content
    const sel = queryParamValueMatches ? `[${DATA_ATTR}=${queryParamValue}]` : '.default';
    componentRoot.querySelectorAll(sel).forEach(node => node.attributes.getNamedItem('class').value += ' shown');
  }
}

export default ConditionalURLContainer;